import request from "@/utils/request";

// 获取当前系统时间
export function loadCurrentDateApi() {
  return request({
    url: "web/common/getCurrentDate",
    method: "post"
  });
}

// 上传附件
export function uploadFileApi(data) {
  return request({
    url: "web/common/uploadFile",
    method: "post",
    data
  });
}

// 作废附件
export function deleteFileApi(data) {
  return request({
    url: "web/common/removeFile",
    method: "post",
    data
  });
}

// 根据条件获取附件信息
export function findAttachmentInfoByConditionApi(data) {
  return request({
    url: "web/attachmentInfo/findAttachmentInfoByCondition",
    method: "post",
    data
  });
}

// 操作附件
export function saveOrUpdateAttachmentInfoApi(data) {
  return request({
    url: "web/attachmentInfo/saveOrUpdate",
    method: "post",
    data
  });
}

// 获取首页数据
export function findStatisticsDataByIndexApi(data) {
  return request({
    url: "web/common/findStatisticsDataByIndex",
    method: "post",
    data
  });
}

// 获取工作看板数据
export function findWorkBoardDataByConditionApi(data) {
  return request({
    url: "web/common/findWorkBoardDataByCondition",
    method: "post",
    data
  });
}

// 获取用户移动端(小程序、APP)区域清单
export function findUserAppAreaDataApi(data) {
  return request({
    url: "web/common/findUserAppAreaData",
    method: "post",
    data
  });
}

// 上传base64图片
export function uploadBase64FileApi(data) {
  return request({
    url: "web/common/uploadBase64File",
    method: "post",
    data
  });
}

// 根据地址获取gps位置
export function findGpsLocationByAddressApi(data) {
  return request({
    url: "web/common/findGpsLocationByAddress",
    method: "post",
    data
  });
}